/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/consistent-type-imports */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState, useRef } from 'react';
import Loader from './Loader';
import './Styles/globals.css';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useDispatch, useSelector } from 'react-redux';
import { setAuthData } from '../store/slices/authSlice';
import type { RootState } from '../store/store';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { NotificationContainer } from 'react-notifications';
import { useIdleTimer } from 'react-idle-timer'
import { getAllClientData } from 'src/services/clientService';
import type { Client, ClientApiResponse, appConfigs } from './types/types';

// import { alpha, styled } from '@mui/material/styles';
// import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { HugeiconsIcon } from '@hugeicons/react';
//@ts-ignore
import { ArrowDown01Icon } from '@hugeicons-pro/core-stroke-standard';

function Header(): JSX.Element {
  const { logout } = useAuth();
  const dispatch = useDispatch();
  const { user, role, token, superadminClientId, appConfigs, appRights } = useSelector((state: RootState) => state.auth);
  const detailsRef = useRef<HTMLDetailsElement>(null);
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  const [clientListData, setClientListData] = useState<Client[]>([])
  const [selectedClientId, setSelectedClientId] = useState<any>(user?.clientId ?? 0);

  const location = useLocation();
  const { pathname } = location;
  const showClientDropdown = !pathname.includes("view-report") && !pathname.includes("new-bulk-campaign") && !pathname.includes("edit-bulk-email") && !pathname.includes("campaign-schedule");

  const getClientData = (): void => {
    getAllClientData(role?.[0]?.roleID ?? undefined)
      .then((res: ClientApiResponse) => {
        if (res.status === 200) {
          if (res.data.result === 1) {
            const clientArr: Client[] = [];
            res.data.data.forEach((data: any) => {
              if (data.isActive) {
                clientArr.push(data);
              }
            });
            clientArr.sort((a: any, b: any) => {
              const nameA = a.clientName;
              const nameB = b.clientName;
              const isAUpper = nameA[0] >= 'A' && nameA[0] <= 'Z';
              const isBUpper = nameB[0] >= 'A' && nameB[0] <= 'Z';
              if (isAUpper !== isBUpper) {
                return isAUpper ? -1 : 1;
              }
              // eslint-disable-next-line @typescript-eslint/no-unsafe-return
              return nameA.localeCompare(nameB);
            });

            setClientListData(clientArr);
            setSelectedClientId(user?.clientId ?? 0);
          }
        }
      })
      .catch(error => console.log("Error: ", error));
  };

  useEffect(() => {
    getClientData();
  }, []);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent): void => {
      if (detailsRef.current && !detailsRef.current.contains(event.target as Node)) {
        detailsRef.current.open = false;
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const onIdle = (): void => {
    handleLogout()
  }

  const storedAppConfig = localStorage.getItem("appConfigs");
  const parsedAppConfig = storedAppConfig
    ? (JSON.parse(storedAppConfig) as appConfigs[])
    : [];

  const tokenExpiryHours = parsedAppConfig.find(
    (item) => item.configName === "ExpiryHour"
  )?.configValue;
  const tokenExpiryTime =
    tokenExpiryHours && !isNaN(Number(tokenExpiryHours))
      ? Number(tokenExpiryHours) * 60 * 60 * 1000
      : 24 * 60 * 60 * 1000;
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { getRemainingTime } = useIdleTimer({
    onIdle,
    timeout: tokenExpiryTime,
    throttle: 500
  })

  const handleLogout = (): void => {
    setIsLoggingOut(true);
    logout();
  };

  const onChange = (event: SelectChangeEvent<string>): void => {
    const selectedId = event.target.value;
    setSelectedClientId(event.target.value)
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const userString: any = localStorage.getItem('user') !== null ? JSON.parse(localStorage.getItem('user')) : null;

    userString.clientId = selectedId;

    const selectedClient = clientListData.find(
      (client) => String(client.id) === String(selectedId)
    );

    userString.espDomainName = selectedClient?.espDomainName ?? null;
    localStorage.setItem('user', JSON.stringify(userString));
    userString.espConnectionId = selectedClient?.espConnectionId ?? null;
    localStorage.setItem('user', JSON.stringify(userString));
    userString.selectedClientName = selectedClient?.clientName ?? null;
    localStorage.setItem('user', JSON.stringify(userString));

    if (user) {
      dispatch(setAuthData({
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        user: localStorage.getItem('user') !== null ? JSON.parse(localStorage.getItem('user')) : null,
        role: role,
        token: token,
        superadminClientId: superadminClientId,
        appConfigs: appConfigs,
        appRights: appRights
      })
      )
    }
  }

  if (isLoggingOut) {
    return (
      <div
        style={{
          position: 'fixed',
          inset: 0,
          zIndex: 9999,
          backgroundColor: 'rgba(255, 255, 255, 0.85)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Loader />
      </div>
    );
  }

  return (
    <div>
      <NotificationContainer />
      <div className="flex gap-x-1 navbar bg-white px-10 h-[60px]">
        <div className="basis-3/5">
          <div className="form-control" style={{ width: '30%' }}>


            {
              showClientDropdown && role && role[0].isClientRole === false &&

              <FormControl variant="standard" fullWidth sx={{ borderBottom: '1px solid #E6ECF2' }}>
                <Select
                  labelId={`bootstrap-select-label`}
                  id={`bootstrap-select`}
                  value={clientListData.length > 0 ? selectedClientId : ""}
                  onChange={onChange}
                  label="Client"
                  IconComponent={(props) => <HugeiconsIcon
                    icon={ArrowDown01Icon}
                    size={18}
                    color="#3A3A3A"
                    strokeWidth={0.5}
                    {...props}

                  />}
                >
                  {
                    clientListData.map((client: Client, index: number) => (
                      <MenuItem value={client.id} key={index}>{client.clientName}</MenuItem>
                    ))
                  }

                </Select>
              </FormControl>
            }
          </div>
        </div>
        <div className="basis-2/5 justify-end">
          {user && (
            <ul className="menu menu-horizontal px-1 profile-badge">
              <li>
                <details ref={detailsRef}>
                  <summary>
                    <p className="profile-heading">
                      <span className="main-heading">
                        {user.firstName} {user.lastName}
                      </span>
                      <br />
                      <span className="prfile-sub-heading">{user.clientName}</span>
                    </p>
                  </summary>
                  <ul className="p-2 bg-base-100 sub-menu mt-[4px] absolute right-0 z-[1001]">
                    <li className="text-14 text-muted">
                      <Link
                        to={`/admin/manage-users/edit/${user.id}`}
                        className="hover:text-muted hover:bg-[#F5F5F5]"
                      >
                        Profile
                      </Link>
                    </li>
                    <li className="text-14 text-muted">
                      <button
                        onClick={handleLogout}
                        className="hover:text-muted hover:bg-[#F5F5F5] w-full text-left"
                      >
                        Logout
                      </button>
                    </li>
                  </ul>
                </details>
              </li>
            </ul>
          )}
          {user && (
            <label tabIndex={0} className="btn btn-ghost btn-circle profile-icon">
              <div className="w-10 rounded-full">
                {user.firstName?.charAt(0) ?? ''}
                {user.lastName?.charAt(0) ?? ''}
              </div>
            </label>
          )}
        </div>
      </div>
    </div>
  );
}

export default Header;